import { AchievementsConnectorApollo } from '@front-activerse/common-components';
import AchievementsContainer from './AchievementsContainer';

const AchievementsPage = () => (
  <AchievementsConnectorApollo>
    {({ ...achievementsData }) => <AchievementsContainer {...achievementsData} />}
  </AchievementsConnectorApollo>
);

export default AchievementsPage;
